import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { ReactSVG } from 'react-svg';
import { Input, LoadingButton, LoadingIndicator } from '@forma/forma-ui-kit';
import { requests, queries } from '@/helpers/api';
import Link from 'next/link';
import { analytics } from '@/helpers/analytics';

import styles from './filling-input-email-and-send.module.css';

const FillingInputEmailAndSend = ({
  idRenderedTemplate,
  firstImagePreviews,
}) => {
  const { t, i18n } = useTranslation();

  const [statusSend, setStatusSend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(null);
  const [email, setEmail] = useState('');
  const [loadImage, setLoadImage] = useState(false);
  const [mailDomain, setMailDomain] = useState({});

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  useEffect(() => {
    if (email.length < 3) {
      setIsError(null);
      return;
    }
    setIsError(validateEmail(email));
  }, [email]);

  const handleClickSend = async () => {
    if (!email) return;

    setIsLoading(true);
    const result = await requests.sendDataToEmail(idRenderedTemplate, {
      email: email
    }, i18n.language);
    setMailDomain(await queries.getMailDomain(email));
    if (!result.error) {
      setStatusSend(true);
    } else {
      setStatusSend(false);
    }

    analytics.clickSendEmailDownload();
  };

  const handleOnLoadImage = () => {
    setLoadImage(true);
  };

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleChangeEmailButton = () => {
    setEmail('');
    setStatusSend(false);
    setIsLoading(false);
  };

  return (
    <div className="container">
      <div className={styles.blockWithInput}>
        {!statusSend ? (
          <>
            <div>{t('we_will_send_link')}</div>
            <Input
              name="email"
              onChange={handleChangeEmail}
              placeholder={t('email')}
              type="email"
              value={email}
              className={
                isError !== null
                  ? !isError
                    ? styles.errorInput
                    : styles.sucessInput
                  : ''
              }
            />
            <LoadingButton
              isLoading={isLoading}
              onClick={handleClickSend}
              disabled={!isError}
            >
              {t('send')}
            </LoadingButton>
            <span className={styles.agreement}>
              <Trans
                i18nKey="user_agreement_form_notice"
                components={{
                  privacy: <Link href="/privacy" target="_blank" />,
                  license: <Link href="/license" target="_blank" />,
                  button: t('send'),
                }}
              />
            </span>
          </>
        ) : (
          <>
            <div className={styles.text}>
              <Trans
                i18nKey="notice_send_user_email"
                values={{ email: email }}
              />
            </div>
            {mailDomain.length !== 0 && (
              <LoadingButton
                className={styles.button}
                viewStyle="secondary"
                as={Link}
                target="_blank"
                href={mailDomain[0].url}
                disabled={!isError}
                icon={
                  <ReactSVG
                    src={mailDomain[0].logoUrl}
                    height={25}
                  />
                }
              >
                {t('open_by', { mail: mailDomain[0].name })}
              </LoadingButton>
            )}
            <a className={styles.accent} onClick={handleChangeEmailButton}>
              {t('change_email')}
            </a>
          </>
        )}
      </div>
      {firstImagePreviews && (
        <div className={styles.wrapperImage}>
          <img
            src={firstImagePreviews.url}
            onLoad={handleOnLoadImage}
            alt="Preview"
            style={{ display: loadImage ? 'block' : 'none' }}
          />
          {!loadImage && <LoadingIndicator />}
        </div>
      )}
    </div>
  );
};

export default FillingInputEmailAndSend;
